import React from 'react';
import {
    getMembershipHistory,
} from '../../../../../Redux/Actions/Admin/ManageMembershipActions';
import { auth } from '../../../../../services';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import {
	Table
} from 'reactstrap';
import { provideIntlService } from '@progress/kendo-react-intl';
import '../../../../PublicView/Pages/MyMemberships/AuthorizedMembers/AuthorizedMembers.scss';

class MembershipHistoryForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			membershipId:this.props.dataItem.membershipId || 0,
		};

	}
	componentDidMount() {
		console.log("MemberHistory", this.props.memberHistory);
		this.props.getMembershipHistory(this.state.membershipId);
	}
	render() {
       return (
                <React.Fragment>
				<div className="account-tab-content">
						<div>
							<div>
								<h1 className="pt-3 pb-3">Membership Transactions</h1>
						    </div>
						</div>
				</div>
				<div className="account-tab-content authorized-members">
                   <div className="table-responsive">
                       <div className="row head">
                       <div className="col-lg-2">
                               <p>Transaction Id</p>
                           </div>
                           <div className="col-lg-2">
                               <p>Organization Name</p>
                           </div>
                           <div className="col-lg-2">
                               <p>Membership Number</p>
                           </div>
                           <div className="col-lg-3">
                               <p>Renew/Join Date</p>
                           </div>
                           <div className="col-lg-3">
                               <p>Expiration Date</p>
                           </div>
                       </div>                       
                        {this.props.memberHistory.length > 0 ? this.props.memberHistory.map((item, i) =>
                            <div className="row">
                                <div className="col-lg-2">
                                    <p>{item.transactionId}</p>
                                </div>
                                <div className="col-lg-2">
                                    <p>{item.organizationName}</p>
                                </div>
                                <div className="col-lg-2">
                                    <p>{item.memberNumber}</p>
                                </div>
                                <div className="col-lg-3">
                                    <p>{provideIntlService(this).formatDate(new Date(item.renewDate), 'MM/d/y')}</p>
                                </div>
                                <div className="col-lg-3">
                                    <p>
                                        {provideIntlService(this).formatDate(new Date(item.membershipExpirationDate), 'MM/d/y')}</p>
                                </div>
                            </div>
                        ) : ""}
					</div>
				</div>
             </React.Fragment>
			);
	}
}

function mapStateToProps(state) {
	return {
		common: state.common,
		memberHistory:state.adminMembership.membershipHistory
	};
}

export default withRouter(
	connect(mapStateToProps, {
		getMembershipHistory,
	})(MembershipHistoryForm)
);
